<template>
  <div style="padding-bottom: 5px; padding-top: 5px;">
    <v-tooltip bottom color="black" open-delay="400">
      <template v-slot:activator="{ on }">
        <div v-on="on" v-html="replaceViewBox(item.silkSVG)" style="width: 45px; padding: 3px; padding-bottom: 0px !important;" @click="openSilksDialog" :style="Object.keys(item.errors).length > 0 ? 'border: solid red 2px;' : ''"></div>
      </template>
      <span>{{ item.description }}</span>
    </v-tooltip>
    <v-dialog v-model="silksDialog"  max-width="600px" persistent>
      <v-card>
        <v-toolbar color="#425058" dark dense>
          <div class="titleBar-content">
            <v-toolbar-title class="raceResults-title"> Silk Info</v-toolbar-title>
            <v-btn class="cancelButton" icon small @click="silksDialog = false, dialogCreateEditStyle = false" ><v-icon class="white--text">mdi-close</v-icon></v-btn>
          </div>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text class="mt-5">
          <div style="display: inline-flex;">
            <div v-html="item.silkSVG" style="width: 220px; margin-top: 24px;"></div>
            <div class="ml-8">
              <v-card elevation="0">
                <v-card-title>{{ item.tabNo }}. <span class="ml-2">{{ item.name }}</span></v-card-title>
                <v-card-subtitle>J: <strong>{{ item.jockey }}</strong></v-card-subtitle>
              </v-card>
              <v-card elevation="0">
                <v-card-title>Original description</v-card-title>
                <v-card-subtitle>
                  <span v-for="(desc, i) in item.description.split(',')" :key="desc+'-'+i">{{ i != item.description.split(',').length - 1 ? desc + ',' : desc }} </span>
                </v-card-subtitle>
              </v-card>
              <v-divider></v-divider>
              <v-card elevation="0">
                <v-card-title :class="item.newDescription !== '' ? 'noPadding' : ''">Rewrite</v-card-title>
                <v-card-subtitle v-if="item.newDescription === ''" class="error--text pt-n2">No rewrite data</v-card-subtitle>
                <v-card-text>
                  <a @click="openStyleDialog(desc)" v-for="(desc, i) in item.newDescription.split(',')" :key="desc">{{ i != item.newDescription.split(',').length - 1 ? desc + ',' : desc }}</a>
                  <v-textarea
                    v-model="newDescription"
                    label="Rewrite for engine"
                    auto-grow
                    rows="2"
                    row-height="35"
                    outlined
                    @click="showButtons"
                    :class="item.newDescription !== '' ? 'newDescriptionFilled' : ''"
                    hide-details
                  ></v-textarea>
                  <v-btn v-if="showSaveButton" small class="white--text" color="success" absolute right style="margin-top: 12px;" @click="saveNewDescription">Save</v-btn>
                </v-card-text>
              </v-card>
            </div>
          </div>
          <div style="margin-top: 20px;">
            <v-card elevation="10">
              <v-card-title class="error--text font-weight-bold" v-if="Object.keys(item.errors).length > 0">Errors Present<v-icon color="error" class="ml-2 mr-1">mdi-cancel</v-icon></v-card-title>
              <v-card-title class="success--text" v-else>No Current Errors<v-icon color="success" class="ml-2 mr-1">mdi-check-circle</v-icon></v-card-title>
              <v-card-text>
                <div v-for="error in Object.keys(item.errors)" :key="error">
                  <!--<a :href="'/silksEditor/'+error">{{ item.errors[error] }}</a>-->
                  <a @click="openStyleDialog(error)">{{ item.errors[error] }}</a>
                </div>
              </v-card-text>
            </v-card>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <CreateStyleModal :dialog="dialog" :fragmentSelected="fragmentSelected" :closeStyleDialog="closeStyleDialog" />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import CreateStyleModal from './CreateStyleModal'
// import namedColors from 'color-name-list'

export default {
  components: {
    CreateStyleModal
  },
  props: {
    item: Object
  },
  data: () => ({
    silksDialog: false,
    dialogCreateEditStyle: false,
    fragment: '',
    showSaveButton: false,
    newDescription: ''
  }),
  computed: {
    dialog () {
      this.loadDescription()
      return this.dialogCreateEditStyle
    },
    fragmentSelected () {
      return this.fragment
    }
  },
  methods: {
    ...mapActions(['fetchStyles', 'saveDescription', 'fetchShapes']),
    replaceViewBox (silkSVG) {
      const svgEdited = silkSVG.replace('viewBox="0 0 29 50"', 'viewBox="0 0 30 50"')
      return svgEdited
    },
    openSilksDialog () {
      // if (!this.newDescription.includes('collar')) {
      //   const arrayDescription = this.newDescription.split(',').map(desc => desc.trim())
      //   const nameColor = arrayDescription[0].replace(/\w\S*/g, function(txt) {
      //     return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
      //   })
      //   const hexColor = namedColors.find(color => color.name === nameColor).hex
      //   console.log(hexColor)
      // }
      this.silksDialog = true
    },
    async openStyleDialog (value) {
      await this.fetchStyles()
      await this.fetchShapes()
      this.fragment = value
      this.silksDialog = false
      this.dialogCreateEditStyle = true
    },
    loadDescription () {
      this.newDescription = this.item.newDescription === '' ? this.item.description : this.item.newDescription
    },
    closeStyleDialog () {
      this.fragment = ''
      this.dialogCreateEditStyle = false
    },
    showButtons () {
      this.showSaveButton = true
    },
    saveNewDescription () {
      this.showSaveButton = false
      this.saveDescription({ newDescription: this.newDescription, runnerNumber: this.item.tabNo })
    }
  }
}
</script>

<style>
  .default{ 
    fill:none; 
    stroke:#231f20; 
    stroke-width: 1% !important; 
  }
  .newDescriptionFilled {
    margin-top: 20px !important;
  }
  .noPadding {
    padding-bottom: 0px;
  }
</style>
